import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { FaturasService } from "../faturas/faturas.service";

declare var swal, $: any;
declare var Chart: any;

@Component({
  selector: 'app-dashboard-financeiro',
  templateUrl: './dashboard-financeiro.component.html'
})
export class DashboardFinanceiroComponent extends Components implements OnInit {

  mesSelected: number;
  anoSelected: number;
  loading: boolean = false;

  mesesList = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' }
  ];

  dashboardData: any = null;

  // Chart instances
  private chart12mInstance: any = null;
  private chartClientsInstance: any = null;
  private chartStatusInstance: any = null;
  private chartPerformedInstance: any = null;
  private chartInvoicedInstance: any = null;
  private chartUnitsInstance: any = null;

  constructor(
    private faturasService: FaturasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();
    const today = new Date();
    this.mesSelected = today.getMonth() + 1;
    this.anoSelected = today.getFullYear();
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    this.loading = true;
    this.faturasService.getDashboardData(this.mesSelected, this.anoSelected)
      .subscribe(
        json => {
          this.loading = false;
          if (json.Success) {
            this.dashboardData = json.Payload;
            setTimeout(() => {
              this.renderCharts();
            }, 100);
          }
        },
        error => {
          this.loading = false;
          this.func.showErro(error.json());
        }
      );
  }

  renderCharts() {
    this.render12mChart();
    this.renderClientsChart();
    this.renderStatusChart();
    this.renderPerformedChart();
    this.renderInvoicedChart();
    this.renderUnitsChart();
  }

  private destroyChart(instance: any) {
    if (instance) {
      instance.destroy();
    }
  }

  render12mChart() {
    this.destroyChart(this.chart12mInstance);
    const canvas = document.getElementById('chart-12m') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const data12 = this.dashboardData.chart12m;

    this.chart12mInstance = new Chart(ctx, {
      type: 'line',
      data: {
        labels: data12.labels,
        datasets: [
          {
            label: 'Faturamento BRL (R$)',
            data: data12.brl,
            borderColor: '#2b5c8f',
            backgroundColor: 'rgba(43, 92, 143, 0.08)',
            borderWidth: 3,
            pointBackgroundColor: '#2b5c8f',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#2b5c8f',
            pointRadius: 4,
            pointHoverRadius: 6,
            lineTension: 0.35,
            fill: true
          },
          {
            label: 'Faturamento USD (US$)',
            data: data12.usd,
            borderColor: '#10b981',
            backgroundColor: 'rgba(16, 185, 129, 0.05)',
            borderWidth: 3,
            pointBackgroundColor: '#10b981',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#10b981',
            pointRadius: 4,
            pointHoverRadius: 6,
            lineTension: 0.35,
            fill: true
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'top',
          labels: {
            usePointStyle: true,
            padding: 15,
            fontFamily: 'Outfit, Inter, sans-serif'
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontFamily: 'Outfit, Inter, sans-serif'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: 'Outfit, Inter, sans-serif',
              callback: function(value) {
                return value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
              }
            }
          }]
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              const value = tooltipItem.yLabel;
              const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
              const currency = datasetLabel.indexOf('USD') !== -1 ? 'US$ ' : 'R$ ';
              return datasetLabel + ': ' + currency + Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          }
        }
      }
    });
  }

  renderClientsChart() {
    this.destroyChart(this.chartClientsInstance);
    const canvas = document.getElementById('chart-clients') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const rawClients = this.dashboardData.topClients || [];

    if (rawClients.length === 0) {
      // Draw empty placeholder if no data
      this.drawEmptyChart(ctx, 'Nenhum cliente faturado no período.');
      return;
    }

    const labels = rawClients.map(c => c.name);
    // Use BRL + USD * 5.5 for relative shares in the pie chart
    const values = rawClients.map(c => c.brl + (c.usd * 5.5));

    const colors = [
      '#4f46e5', '#3b82f6', '#10b981', '#f59e0b', '#ef4444',
      '#8b5cf6', '#ec4899', '#14b8a6', '#6b7280', '#06b6d4'
    ];

    this.chartClientsInstance = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [{
          data: values,
          backgroundColor: colors.slice(0, labels.length),
          borderWidth: 2,
          borderColor: '#ffffff'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            boxWidth: 12,
            fontFamily: 'Outfit, Inter, sans-serif',
            padding: 8
          }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const index = tooltipItem.index;
              const client = rawClients[index];
              const name = data.labels[index] || '';
              const details = [];
              if (client.brl > 0) details.push('R$ ' + Number(client.brl).toLocaleString('pt-BR', { minimumFractionDigits: 2 }));
              if (client.usd > 0) details.push('US$ ' + Number(client.usd).toLocaleString('pt-BR', { minimumFractionDigits: 2 }));
              return name + ': ' + details.join(' / ');
            }
          }
        }
      }
    });
  }

  renderStatusChart() {
    this.destroyChart(this.chartStatusInstance);
    const canvas = document.getElementById('chart-status') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const counts = this.dashboardData.statusCounts;

    const labels = ['Enviada', 'Aceita', 'Paga', 'Cancelada', 'Gerado'];
    const data = [counts.enviada, counts.aceita, counts.paga, counts.cancelada, counts.gerado];

    const total = data.reduce((acc, val) => acc + val, 0);
    if (total === 0) {
      this.drawEmptyChart(ctx, 'Nenhuma fatura encontrada.');
      return;
    }

    const colors = ['#f59e0b', '#3b82f6', '#10b981', '#ef4444', '#6b7280'];

    this.chartStatusInstance = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderWidth: 2,
          borderColor: '#ffffff'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 60,
        legend: {
          position: 'right',
          labels: {
            boxWidth: 12,
            fontFamily: 'Outfit, Inter, sans-serif',
            padding: 10
          }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const index = tooltipItem.index;
              const value = data.datasets[tooltipItem.datasetIndex].data[index];
              const pct = ((value / total) * 100).toFixed(1);
              return data.labels[index] + ': ' + value + ' fatura(s) (' + pct + '%)';
            }
          }
        }
      }
    });
  }

  renderPerformedChart() {
    this.destroyChart(this.chartPerformedInstance);
    const canvas = document.getElementById('chart-performed') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const perf = this.dashboardData.performed;

    const labels = ['Preliminares', 'Laudos PDF', 'Laudos CD', 'Laudos Técnicos'];
    const data = [perf.fichas.total, perf.laudos_pdf.total, perf.laudos_cd.total, perf.laudos_tecnicos.total];

    const total = data.reduce((acc, val) => acc + val, 0);
    if (total === 0) {
      this.drawEmptyChart(ctx, 'Nenhum item realizado.');
      return;
    }

    const colors = ['#6366f1', '#ec4899', '#a855f7', '#06b6d4'];

    this.chartPerformedInstance = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderWidth: 2,
          borderColor: '#ffffff'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            boxWidth: 12,
            fontFamily: 'Outfit, Inter, sans-serif',
            padding: 10
          }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const index = tooltipItem.index;
              const value = data.datasets[tooltipItem.datasetIndex].data[index];
              const pct = ((value / total) * 100).toFixed(1);
              return data.labels[index] + ': ' + value + ' unidade(s) (' + pct + '%)';
            }
          }
        }
      }
    });
  }

  renderInvoicedChart() {
    this.destroyChart(this.chartInvoicedInstance);
    const canvas = document.getElementById('chart-invoiced') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const perf = this.dashboardData.performed;

    const labels = ['Preliminares', 'Laudos PDF', 'Laudos CD', 'Laudos Técnicos'];
    const invoicedData = [perf.fichas.faturado, perf.laudos_pdf.faturado, perf.laudos_cd.faturado, perf.laudos_tecnicos.faturado];
    const nonInvoicedData = [perf.fichas.nao_faturado, perf.laudos_pdf.nao_faturado, perf.laudos_cd.nao_faturado, perf.laudos_tecnicos.nao_faturado];

    this.chartInvoicedInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Faturados',
            data: invoicedData,
            backgroundColor: '#10b981',
            borderRadius: 4
          },
          {
            label: 'Não Faturados',
            data: nonInvoicedData,
            backgroundColor: '#ef4444',
            borderRadius: 4
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'top',
          labels: {
            boxWidth: 12,
            fontFamily: 'Outfit, Inter, sans-serif'
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              fontFamily: 'Outfit, Inter, sans-serif'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: 'Outfit, Inter, sans-serif',
              stepSize: 5,
              callback: function(value) {
                return value.toLocaleString('pt-BR');
              }
            }
          }]
        }
      }
    });
  }

  renderUnitsChart() {
    this.destroyChart(this.chartUnitsInstance);
    const canvas = document.getElementById('chart-units') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const units = this.dashboardData.units || [];

    if (units.length === 0) {
      this.drawEmptyChart(ctx, 'Nenhum faturamento por unidade no período.');
      return;
    }

    const labels = units.map(u => u.name);
    const brlData = units.map(u => u.brl);
    const usdData = units.map(u => u.usd);

    this.chartUnitsInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Faturamento BRL (R$)',
            data: brlData,
            backgroundColor: '#4f46e5'
          },
          {
            label: 'Faturamento USD (US$)',
            data: usdData,
            backgroundColor: '#06b6d4'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'top',
          labels: {
            boxWidth: 12,
            fontFamily: 'Outfit, Inter, sans-serif'
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              fontFamily: 'Outfit, Inter, sans-serif'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: 'Outfit, Inter, sans-serif',
              callback: function(value) {
                return value.toLocaleString('pt-BR');
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const value = tooltipItem.yLabel;
              const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
              const currency = datasetLabel.indexOf('USD') !== -1 ? 'US$ ' : 'R$ ';
              return datasetLabel + ': ' + currency + Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            }
          }
        }
      }
    });
  }

  private drawEmptyChart(ctx: CanvasRenderingContext2D, message: string) {
    const width = ctx.canvas.clientWidth;
    const height = ctx.canvas.clientHeight;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#6b7280';
    ctx.font = '14px Outfit, Inter, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(message, width / 2, height / 2);
  }

  // Format Helper
  formatCurrency(value, currencyIso) {
    if (value === null || value === undefined) return '';
    const number = Number(value);
    const formatted = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (currencyIso || 'BRL') === 'USD' ? `US$ ${formatted}` : `R$ ${formatted}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/financeiro/dashboard-financeiro.component.ts